const initialState = {
    costTemplates: [],
    loading: false,
    error: null,
    createLoading: false,
    createError: null,
    updateLoading: false,
    updateError: null,
    deleteLoading: false,
    deleteError: null,
};

export const CostTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        // Create Cost Template
        case 'COST_TEMPLATE_CREATE_REQUEST':
            return { ...state, createLoading: true, createError: null };
        case 'COST_TEMPLATE_CREATE_SUCCESS':
            return {
                ...state,
                createLoading: false,
                costTemplates: [action.payload, ...state.costTemplates],
            };
        case 'COST_TEMPLATE_CREATE_FAIL':
            return { ...state, createLoading: false, createError: action.payload };

        // Fetch All Cost Templates
        case 'COST_TEMPLATE_FETCH_ALL_REQUEST':
            return { ...state, loading: true, error: null };
        case 'COST_TEMPLATE_FETCH_ALL_SUCCESS':
            return { ...state, loading: false, costTemplates: action.payload };
        case 'COST_TEMPLATE_FETCH_ALL_FAIL':
            return { ...state, loading: false, error: action.payload };

        // Update Cost Template
        case 'COST_TEMPLATE_UPDATE_REQUEST':
            return { ...state, updateLoading: true, updateError: null };
        case 'COST_TEMPLATE_UPDATE_SUCCESS':
            return {
                ...state,
                updateLoading: false,
                costTemplates: state.costTemplates.map((template) =>
                    template._id === action.payload._id ? action.payload : template
                ),
            };
        case 'COST_TEMPLATE_UPDATE_FAIL':
            return { ...state, updateLoading: false, updateError: action.payload };

        // Delete Cost Template
        case 'COST_TEMPLATE_DELETE_REQUEST':
            return { ...state, deleteLoading: true, deleteError: null };
        case 'COST_TEMPLATE_DELETE_SUCCESS':
            return {
                ...state,
                deleteLoading: false,
                costTemplates: state.costTemplates.filter((template) => template._id !== action.payload),
            };
        case 'COST_TEMPLATE_DELETE_FAIL':
            return { ...state, deleteLoading: false, deleteError: action.payload };

        default:
            return state;
    }
};